import superagent from "superagent";
import normalizeObject from "../../utils/normalizeObject";
import middleware from "./railsMiddleware";
import unauthorizedMiddleware from "./unauthorizedMiddleware";
import { API_URL } from "@shared/env";

export function serializeSnakeCase(data) {
  return JSON.stringify(normalizeObject(data, "snake"));
}

const api = (method) => (url) => {
  return superagent[method](`${API_URL}${url}`)
    .use(middleware)
    .use(unauthorizedMiddleware)
    .type("json")
    .accept("json")
    .serialize(serializeSnakeCase);
};

export const apiGet = api("get");
export const apiPost = api("post");
export const apiPatch = api("patch");
export const apiDel = api("del");
export const apiPut = api("put");
export const baseUrl = API_URL;
